<app-navbar></app-navbar>
<div class="container mt-5">
    <h3><img src="../../../assets/img/consecutivo.png" width="70" alt="">Pedidos Realizados:</h3>
    <hr>
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-dark">
                <tr>
                    <th scope="col">Usuario</th>
                    <th scope="col">Tipo</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Referencia</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of pedidos">
                    <td><b>{{item.nombre}}</b></td>
                    <td>{{item.tipo}}</td>
                    <td>{{item.estado}}</td>
                    <td>{{item.fecha | date}}</td>
                    <td>{{item.refCompra}}</td>
                    <td>
                        <button title="Ver detalle" class="btn btn-primary" (click)="detalle(item)" data-toggle="modal" data-target="#pedidos"><i class="fa fa-list"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="pedidos" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Detalle de Pedido:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col">Producto</th>
                                <th scope="col">Cantidad</th>
                                <th scope="col">Presentación</th>
                                <th scope="col">Tamaño</th>
                                <th scope="col">Color</th>
                                <th scope="col">Precio</th>
                                <th scope="col">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of carrito">
                                <td><b>{{item.nombre}}</b></td>
                                <td>{{item.cantidad}}</td>
                                <td>{{item.presentacion}}</td>
                                <td>{{item.tamano}}</td>
                                <td>{{item.color}}</td>
                                <td>${{item.precio | number}}</td>
                                <td>${{item.total | number}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>